import CaseStudiesList from './CaseStudiesList';
// import CaseStudiesCreate from './CaseStudiesCreate';
// import CaseStudiesEdit from './CaseStudiesEdit';

export const caseStudies = {
  list: CaseStudiesList,
  //   create: CaseStudiesCreate,
  //   edit: CaseStudiesEdit,
};
